import { render, staticRenderFns } from "./PsychTest.vue?vue&type=template&id=23051f52&scoped=true&"
import script from "./PsychTest.vue?vue&type=script&lang=js&"
export * from "./PsychTest.vue?vue&type=script&lang=js&"
import style0 from "./PsychTest.vue?vue&type=style&index=0&id=23051f52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23051f52",
  null
  
)

export default component.exports